(() => {
    const datePickerDropDowns = document.querySelectorAll('.daterange')
    datePickerDropDowns.forEach(async (dp) => {
        const { Datepicker } = await import(/* webpackChunkName: "datepickerFactory" */'./Datepicker')
        new Datepicker(dp) 
    })
})()